import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
// Se eliminan Shield y Trophy de los imports
import { ShoppingCart, User, Search, Heart, Menu } from 'lucide-react';
import { useCart } from '../context/CartContext';

const Header = ({ onCartClick }) => {
  const { getTotalItems } = useCart();
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (e) => {
    if (e.key === 'Enter' && searchTerm.trim() !== '') {
      navigate(`/search?q=${encodeURIComponent(searchTerm)}`);
    }
  };

  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="bg-white/95 backdrop-blur-md border-b border-red-200/50 sticky top-0 z-50 shadow-lg"
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            {/* --- MODIFICACIÓN AQUÍ --- */}
            <motion.div
              whileHover={{ scale: 1.1, rotate: 5 }}
              transition={{ type: 'spring', stiffness: 300 }}
              className="relative"
            >
              {/* Se reemplaza el div con el ícono por una etiqueta img */}
              <img 
                src="/icon.png" 
                alt="Logo Club Romerense" 
                className="w-12 h-12 object-contain"
              />
            </motion.div>
            {/* --- FIN DE LA MODIFICACIÓN --- */}
            <div className="flex flex-col">
              <span className="text-2xl font-bold text-gradient">Club Romerense</span>
              <span className="text-xs text-red-600 font-medium">Tienda Oficial</span>
            </div>
          </Link>

          {/* Search Bar */}
          <div className="hidden md:flex flex-1 max-w-md mx-8">
            <div className="relative w-full">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Buscar productos del club..."
                className="w-full pl-10 pr-4 py-3 border border-red-200 rounded-full focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white/80 backdrop-blur-sm"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={handleSearch}
              />
            </div>
          </div>

          {/* Navigation */}
          <div className="flex items-center space-x-4">
            {/* Legal Notice Link */}
            <div className="hidden lg:flex items-center space-x-4">
              <Link to="/aviso-legal" className="text-gray-700 hover:text-red-600 transition-colors font-medium">
                Aviso Legal
              </Link>
            </div>

            {/* Icons */}
            <div className="flex items-center space-x-3">
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="p-2 rounded-full hover:bg-red-50 transition-colors"
              >
                <Heart className="w-6 h-6 text-gray-600 hover:text-red-600" />
              </motion.button>

              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={onCartClick}
                className="relative p-2 rounded-full hover:bg-red-50 transition-colors"
              >
                <ShoppingCart className="w-6 h-6 text-gray-600 hover:text-red-600" />
                {getTotalItems() > 0 && (
                  <motion.span
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    className="absolute -top-1 -right-1 bg-red-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold"
                  >
                    {getTotalItems()}
                  </motion.span>
                )}
              </motion.button>

              <Link to="/admin/login">
                <motion.button
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  className="p-2 rounded-full hover:bg-red-50 transition-colors"
                >
                  <User className="w-6 h-6 text-gray-600 hover:text-red-600" />
                </motion.button>
              </Link>

              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="md:hidden p-2 rounded-full hover:bg-red-50 transition-colors"
              >
                <Menu className="w-6 h-6 text-gray-600 hover:text-red-600" />
              </motion.button>
            </div>
          </div>
        </div>

        {/* Mobile Search */}
        <div className="md:hidden mt-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder="Buscar productos del club..."
              className="w-full pl-10 pr-4 py-3 border border-red-200 rounded-full focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white/80 backdrop-blur-sm"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={handleSearch}
            />
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
